const windowDefaultState = {
  orientation: 'landscape',
  fullscreen: false,
  popoutMode: false
}

export default (state = windowDefaultState, action) => {
  switch (action.type) {
    case 'WINDOW::ORIENTATION::CHANGE':
      return {
        ...state,
        orientation: action.orientation
      }
    case 'WINDOW::FULLSCREEN::CHANGE':
      return {
        ...state,
        fullscreen: action.fullscreen
      }
    case 'WINDOW::POPOUT_MODE::CHANGE':
      return {
        ...state,
        popoutMode: action.popoutMode
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/window.js